module.exports = __webpack_public_path__ + "static/media/HJ-2E成像模式.48f35291.jpg";